import styled from 'styled-components';

export const OvalButton = styled.button`
  cursor: pointer;
  border: 0;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 32, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.14);
  padding: 0 10px;
  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  /* кнопка в размер полей ввода (как поля ввода и CustomSelect) */
  &.field {
    height: 40px;
    border-radius: 8px;
    font-size: 14px;
    padding: 0 20px;
    box-sizing: border-box;
  }
  &.big {
    height: 45px;
    font-size: 20px;
    padding: 0 20px;
  }
`;

export const RedButton = styled(OvalButton)`
  transition: filter 0.15s ease-in;
  line-height: normal;
  background: linear-gradient(90deg, #d8434f 0%, #cc2936 100%);
  &:hover {
    filter: brightness(1.06);
  }
  &[disabled] {
    &:hover {
      filter: none;
    }
  }
`;

export const GreenButton = styled(OvalButton)`
  transition: filter 0.15s ease-in;
  background: linear-gradient(90deg, #5cc98a 0%, #3aa863 100%);
  &:hover {
    filter: brightness(1.06);
  }
`;

export const BlueButton = styled(OvalButton)`
  background: linear-gradient(90deg, #5cc98a 0%, #3aa863 100%);
  transition: filter 0.15s ease-in;
  &:hover {
    filter: brightness(1.06);
  }
  &:active {
    filter: brightness(0.95);
  }
  &[disabled] {
    &:hover {
      filter: none;
    }
  }
  &.loading::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5) url(/images/loader.svg) no-repeat 50% 50%;
    background-size: 18px auto;
  }
`;

export const BlackButton = styled(BlueButton)`
  background: linear-gradient(#383c3f, #2f3235);
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.8);
`;

export const WhiteButton = styled(OvalButton)`
  color: #e6eaec;
  background: #1a2429;
  border: 1px solid #3d4952;
  transition: border-color 0.15s ease-in, color 0.15s ease-in;
  &:hover {
    border-color: #47b972;
    color: #5cc98a;
  }
  &[disabled] {
    &:hover {
      border-color: #3d4952;
      color: #e6eaec;
    }
  }
`;

export const GrayButton = styled(OvalButton)`
  box-shadow: none;
  img {
    margin-right: 10px;
  }
  background: #141c18;
  color: #e6eaec;
  border: 1px solid #3d4952;
  position: relative;
  transition: border-color 0.15s ease-in, background 0.15s ease-in;
  &:hover {
    background: #232e35;
    border-color: #47b972;
  }
  &:disabled {
    opacity: 0.5;
    &:hover {
      background: #141c18;
      border-color: #3d4952;
    }
  }
  &.loading::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5) url(/images/loader.svg) no-repeat 50% 50%;
    background-size: 18px auto;
  }
`;
